export const initialFeatureFlags = {
  paymentMethodModalHeader: true,
};
